<app-workflow-upgrade-one *ngIf="isOneUpgrade"></app-workflow-upgrade-one>
<app-workflow-cancel-subscription *ngIf="isCancelSubscription"></app-workflow-cancel-subscription>
<app-workflow-phonenumbers *ngIf="isPhonenumbers"></app-workflow-phonenumbers>
<app-workflow-itemized-billing *ngIf="isItemizedBilling"></app-workflow-itemized-billing>
<app-workflow-tariff *ngIf="isTariff"></app-workflow-tariff>
<app-workflow-tariff-cancel *ngIf="isTariffCancel"></app-workflow-tariff-cancel>
<div *ngIf="!isInWorkflow">
  <a routerLink="/">{{'not_in_workflow_link' | i18next}}</a>
</div>
